import { render, staticRenderFns } from "./businessArea.vue?vue&type=template&id=509b0464&scoped=true"
import script from "./businessArea.vue?vue&type=script&lang=js"
export * from "./businessArea.vue?vue&type=script&lang=js"
import style0 from "./businessArea.vue?vue&type=style&index=0&id=509b0464&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "509b0464",
  null
  
)

export default component.exports